export default __webpack_public_path__ + "media/images/icons/new-twitter-7d97eaabe4f9215e38ae8de1b209b068.svg";